import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule } from '@angular/material/tooltip';
import { MAT_TOOLTIP_OPTIONS } from '@portal/data-access';
import { BytesizeIconPipe } from '@portal/pipe';
import { DatetimeModule, SafeSourceHtmlModule } from '../../pipes';
import { AddSignatureModalComponent } from '../add-signature-modal/add-signature-modal.component';
import { SignatureBoxComponent } from './signature-box.component';

const pipes = [DatetimeModule, SafeSourceHtmlModule, BytesizeIconPipe];

@NgModule({
  declarations: [AddSignatureModalComponent, SignatureBoxComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatSliderModule, MatTooltipModule, MatTabsModule, ...pipes],
  exports: [SignatureBoxComponent],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: MAT_TOOLTIP_OPTIONS }],
})
export class SignatureBoxModule {}
